import { toast } from "react-hot-toast";

export const handleApiError = (
  err: any,
  fallbackMessage = "Something went wrong."
) => {
  const message =
    err?.response?.data?.error?.toString() ??
    err?.response?.data?.message?.toString() ??
    err?.message?.toString() ??
    fallbackMessage;

  console.error("API Error:", err);
  toast.error(message);
};
